/* Rhapsodye personalised tote: name boxes + live preview on the product page.
   Source: D:\Claude\Personalised Tote\web\rhapsodye-personalise.js  (uploaded to Shopify Files)
   Layout numbers come from ptote-config.json, built by export_web.py from the SAME templates
   the print renderer (render_tote.py) uses, so the preview matches the printed bag. */
(function () {
  var root = document.getElementById('ptote');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var params = new URLSearchParams(location.search);
  var designKey = root.dataset.design || params.get('ptote') || '';
  var form = document.getElementById(root.dataset.form);

  var CRAFTS = ['Knitting', 'Crochet', 'Spinning', 'Weaving', 'Cross-Stitch', 'Embroidery', 'Quilting', 'Sewing'];
  var MAX = { NAME: 20, NAME2: 20, CRAFT: 16 };
  var LABELS = {
    'make-me-something': { NAME: 'Who is being asked? (e.g. Grandma)', NAME2: 'Who is asking? (e.g. Lily)' }
  };
  var DEFAULTS = { NAME: 'Margaret', NAME2: 'Lily', CRAFT: 'Knitting' };
  var PROP = { NAME: 'Name', NAME2: 'Second name', CRAFT: 'Craft' };
  // A short courtesy filter. The order tool runs a fuller check and holds anything doubtful for Em.
  // Racist / homophobic wording is refused here, before anyone pays (Em, 11 Oct). Normal swearing is fine.
  // The list lives in the config (blocked_words.json -> export_web.py), shared with the order tool.
  var LEET = { '0': 'o', '1': 'i', '3': 'e', '4': 'a', '5': 's', '7': 't', '@': 'a', '$': 's' };
  var OK_CHARS = /^[\p{L}][\p{L}\p{M} '’.\-&]*$/u;
  var BAG = { black: '#181818', oyster: '#e8e1d3' };

  var store = {
    get: function (k) { try { return sessionStorage.getItem('ptote_' + k) || ''; } catch (e) { return ''; } },
    set: function (k, v) { try { sessionStorage.setItem('ptote_' + k, v); } catch (e) {} }
  };

  // ------------------------------------------------------------------ text helpers (mirror render_tote.py)
  function tidy(text, mode) {
    text = (text || '').trim().replace(/\s+/g, ' ');
    if (mode === 'upper') return text.toUpperCase();
    if (mode === 'tidy' && (text === text.toUpperCase() || text === text.toLowerCase())) {
      return text.split(' ').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join(' ');
    }
    return text;
  }
  function fill(template, values, mode) {
    var out = template;
    Object.keys(values).forEach(function (k) { out = out.split('{' + k + '}').join(tidy(values[k], mode)); });
    return mode === 'upper' ? out.toUpperCase() : out;
  }
  function font(size, family) { return size + 'px "' + family + '"'; }

  // ------------------------------------------------------------------ drawing
  var cfg, design, canvas, ctx, images = {}, scheduled = false, generation = 0;

  function loadImage(url) {
    if (!images[url]) {
      images[url] = new Promise(function (res, rej) {
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () { res(im); }; im.onerror = rej; im.src = url;
      });
    }
    return images[url];
  }

  function drawLine(f, text, s) {
    var size = f.size;
    ctx.font = font(size * s, f.family);
    var w = ctx.measureText(text).width;
    if (w > f.max_width * s) { size *= f.max_width * s / w; ctx.font = font(size * s, f.family); }
    ctx.fillStyle = 'rgb(' + f.colour.join(',') + ')';
    ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
    ctx.fillText(text, f.cx * s, f.baseline * s);
  }

  function wrap(text, width) {
    var words = text.split(' '), lines = [], cur = '';
    words.forEach(function (w) {
      var trial = (cur + ' ' + w).trim();
      if (cur && ctx.measureText(trial).width > width) { lines.push(cur); cur = w; } else { cur = trial; }
    });
    return lines.concat([cur]);
  }

  function drawParagraph(p, text, s) {
    var size = p.size, lines, widest;
    for (;;) {
      ctx.font = font(size * s, p.family);
      lines = wrap(text, p.max_width * s);
      widest = Math.max.apply(null, lines.map(function (l) { return ctx.measureText(l).width; }));
      var fits = lines.length <= (p.max_lines || 99) && lines.length * p.line_pitch * size / p.size <= p.max_height;
      if ((fits && widest <= p.max_width * s) || size < 80) break;
      size *= 0.94;
    }
    var pitch = p.line_pitch * size / p.size * s;
    var m0 = ctx.measureText(lines[0]), mN = ctx.measureText(lines[lines.length - 1]);
    var top = -m0.actualBoundingBoxAscent, bottom = (lines.length - 1) * pitch + mN.actualBoundingBoxDescent;
    ctx.save();
    ctx.translate(p.centre[0] * s, p.centre[1] * s);
    ctx.rotate(-p.angle * Math.PI / 180);
    ctx.fillStyle = 'rgb(' + p.colour.join(',') + ')';
    ctx.textAlign = 'center'; ctx.textBaseline = 'alphabetic';
    lines.forEach(function (l, i) { ctx.fillText(l, 0, -(top + bottom) / 2 + i * pitch); });
    ctx.restore();
  }

  function capHeight(family, size) {
    ctx.font = font(size, family);
    var m = ctx.measureText('H');
    return m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
  }

  // Accent for a yarn letter: the font's accented capital minus its plain capital (as render_tote.py does).
  function accentMask(base, accented, family, size) {
    var W = Math.ceil(size * 2), c = document.createElement('canvas'); c.width = c.height = W;
    var x = c.getContext('2d');
    function alpha(ch) {
      x.clearRect(0, 0, W, W); x.font = font(size, family); x.textBaseline = 'alphabetic'; x.fillStyle = '#000';
      x.fillText(ch, size * 0.4, size * 1.3);
      return x.getImageData(0, 0, W, W).data;
    }
    var a = alpha(base), b = alpha(accented);
    var g = [W, W, 0, 0], ac = [W, W, 0, 0], diff = new Uint8ClampedArray(W * W);
    for (var i = 0; i < W * W; i++) {
      var px = i % W, py = (i / W) | 0;
      if (a[i * 4 + 3] > 128) { g[0] = Math.min(g[0], px); g[1] = Math.min(g[1], py); g[2] = Math.max(g[2], px); g[3] = Math.max(g[3], py); }
      if (b[i * 4 + 3] > 128 && a[i * 4 + 3] <= 128) {
        diff[i] = 255;
        ac[0] = Math.min(ac[0], px); ac[1] = Math.min(ac[1], py); ac[2] = Math.max(ac[2], px); ac[3] = Math.max(ac[3], py);
      }
    }
    if (ac[2] < ac[0] || g[2] < g[0]) return null;
    var w = ac[2] - ac[0] + 1, h = ac[3] - ac[1] + 1, out = document.createElement('canvas');
    out.width = w; out.height = h;
    var o = out.getContext('2d'), id = o.createImageData(w, h);
    for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
      var v = diff[(ac[1] + yy) * W + ac[0] + xx];
      id.data[(yy * w + xx) * 4 + 3] = v;
    }
    o.putImageData(id, 0, 0);
    return { img: out, above: ac[3] <= g[1] + 2, gap: ac[3] <= g[1] + 2 ? g[1] - ac[3] : ac[1] - g[3] };
  }

  // Old-storybook first page (Em, 10 Oct). Mirrors render_tote.py render_dropcap step for step, in the print
  // file's own 4125px layout units; the finished block is then scaled to fit inside the double-rule frame.
  function capSize(family, capH) { return 200 * capH / capHeight(family, 200); }
  function charsWidth(text, spacing) {
    var w = 0;
    for (var i = 0; i < text.length; i++) w += ctx.measureText(text[i]).width;
    return w + (spacing || 0) * Math.max(0, text.length - 1);
  }

  function drawDropcap(dc, name, craft, C) {
    var Lo = dc.layout, CL = cfg.canvas, s = C / CL, ink = 'rgb(' + dc.colour.join(',') + ')';
    name = tidy(name, 'tidy');
    var first = name.charAt(0).toUpperCase(), rest = name.slice(1).toUpperCase() + '’S';
    var craftLine = tidy(craft, 'upper') + ' BAG';
    var words = dc.craft_words[craft.trim().replace(/\s+/g, ' ').toLowerCase()] || dc.default_words;
    var body = dc.body.replace('{a}', words[0]).replace('{b}', words[1]).replace('{c}', words[2]);
    var base = first.normalize('NFD').charAt(0);
    var yarn = /^[A-Z]$/.test(base) ? dc.letters[base] : null;
    var gen = generation;
    return (yarn ? loadImage(yarn.url || yarn.file) : Promise.resolve(null)).then(function (img) {
      if (gen !== generation) return;                                  // a newer keystroke is already drawing
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.fillStyle = BAG[design.bag]; ctx.fillRect(0, 0, C, C);
      var L = Lo.left, R = Lo.right, topY = Lo.top, LH = Lo.letter_h;
      // the letter, in its own pixels: body top/bottom/right and whole-art box (yarn included)
      var lt, lb, lr, box, acc = null, plain = null;
      if (img) {
        lt = yarn.top; lb = yarn.bottom; lr = yarn.right;
        box = [yarn.a_left, yarn.a_top, yarn.a_right, yarn.a_bottom];
        if (base !== first) {
          var a = accentMask(base, first, dc.family, capSize(dc.family, lb - lt));
          if (a) {
            var k = 0.75, aw = a.img.width * k, ah = a.img.height * k, lh = lb - lt;
            var ax = (yarn.left + yarn.right) / 2 - aw / 2;
            var ay = a.above ? lt - Math.max(a.gap * k, lh * 0.05) - ah : lb + Math.max(a.gap * k, lh * 0.02);
            acc = { img: a.img, x: ax, y: ay, w: aw, h: ah };
            box = [Math.min(box[0], ax), Math.min(box[1], ay), Math.max(box[2], ax + aw), Math.max(box[3], ay + ah)];
          }
        }
      } else {                                                          // no yarn version (Ø, Ł...): plain capital
        var ps = capSize(dc.family, LH);
        ctx.font = font(ps, dc.family);
        var m = ctx.measureText(first);
        plain = { size: ps };
        lt = 0; lb = LH; lr = m.width;
        box = [-m.actualBoundingBoxLeft, LH - m.actualBoundingBoxAscent, m.actualBoundingBoxRight, LH + m.actualBoundingBoxDescent];
      }
      var sc = LH / (lb - lt);
      var wide = Math.max(lr, box[2]) * sc, room = Lo.max_letter_w * (R - L);
      if (wide > room) sc *= room / wide;
      var cx = Lo.letter_x, cy = topY - lt * sc;
      var capBottom = cy + box[3] * sc;
      var x0 = cx + Math.max(lr, box[2]) * sc + Lo.gap, colw = R - x0, right = x0;
      var ops = [];
      // rest of the name
      var s1 = capSize(dc.family, Lo.name_cap);
      ctx.font = font(s1, dc.family);
      var w = charsWidth(rest);
      if (w > colw) { s1 = capSize(dc.family, Lo.name_cap * colw / w); ctx.font = font(s1, dc.family); }
      var h1 = capHeight(dc.family, s1), b1 = topY + h1;
      ops.push({ t: rest, x: x0, y: b1, f: font(s1, dc.family) });
      ctx.font = font(s1, dc.family); right = Math.max(right, x0 + charsWidth(rest));
      // craft line, letter-spaced
      var s2 = capSize(dc.family, Lo.craft_cap), sp = Lo.craft_spacing;
      ctx.font = font(s2, dc.family);
      w = charsWidth(craftLine, sp);
      if (w > colw) s2 = capSize(dc.family, Lo.craft_cap * colw / w);
      var b2 = b1 + Lo.line_gap + capHeight(dc.family, s2), x = x0;
      ctx.font = font(s2, dc.family);
      for (var i = 0; i < craftLine.length; i++) {
        ops.push({ t: craftLine[i], x: x, y: b2, f: font(s2, dc.family) });
        x += ctx.measureText(craftLine[i]).width + sp;
      }
      right = Math.max(right, x - sp);
      // paragraph: beside the letter, then full width once below the yarn
      var bfont = font(Lo.body_size, dc.body_family);
      ctx.font = bfont;
      var asc = ctx.measureText('H').fontBoundingBoxAscent || Lo.body_size * 0.9;
      var todo = body.split(' '), yb = b2 + Lo.body_gap;
      while (todo.length) {
        var lx = yb - asc - 30 < capBottom ? x0 : L, line = [todo.shift()];
        while (todo.length && ctx.measureText(line.concat([todo[0]]).join(' ')).width <= R - lx) line.push(todo.shift());
        var txt = line.join(' ');
        ops.push({ t: txt, x: lx, y: yb, f: bfont });
        right = Math.max(right, lx + ctx.measureText(txt).width);
        yb += Lo.body_lead;
      }
      var oy = Math.max(yb, capBottom) + Lo.orn_gap, mid = (L + R) / 2, o0 = Lo.orn_line[0], o1 = Lo.orn_line[1], od = Lo.orn_d;
      // fit the whole block inside the frame, centred
      var bx0 = Math.min(cx + box[0] * sc, L), by0 = Math.min(cy + box[1] * sc, b1 - h1);
      var bx1 = Math.max(right, mid + o1), by1 = oy + od;
      var avail = CL - 2 * (Lo.frame + Lo.inner_gap + Lo.pad);
      var kk = Math.min(1, avail / (bx1 - bx0), avail / (by1 - by0));
      ctx.setTransform(kk * s, 0, 0, kk * s, (CL / 2 - (bx0 + bx1) / 2 * kk) * s, (CL / 2 - (by0 + by1) / 2 * kk) * s);
      if (img) {
        ctx.drawImage(img, cx, cy, yarn.w * sc, yarn.h * sc);
        if (acc) ctx.drawImage(tint(acc.img, ink), cx + acc.x * sc, cy + acc.y * sc, acc.w * sc, acc.h * sc);
      } else {
        ctx.fillStyle = ink; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
        ctx.font = font(plain.size * sc, dc.family);
        ctx.fillText(first, cx, cy + LH * sc);
      }
      ctx.fillStyle = ink; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
      ops.forEach(function (o) { ctx.font = o.f; ctx.fillText(o.t, o.x, o.y); });
      ctx.strokeStyle = ink; ctx.lineWidth = Lo.orn_w;
      ctx.beginPath(); ctx.moveTo(mid - o1, oy); ctx.lineTo(mid - o0, oy); ctx.moveTo(mid + o0, oy); ctx.lineTo(mid + o1, oy); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(mid, oy - od); ctx.lineTo(mid + od, oy); ctx.lineTo(mid, oy + od); ctx.lineTo(mid - od, oy); ctx.closePath(); ctx.fill();
      // double-rule frame (PIL draws outlines inward from the rectangle edge)
      ctx.setTransform(s, 0, 0, s, 0, 0);
      var M = Lo.frame, g = Lo.inner_gap;
      ctx.lineWidth = Lo.frame_w; ctx.strokeRect(M + Lo.frame_w / 2, M + Lo.frame_w / 2, CL - 2 * M - Lo.frame_w, CL - 2 * M - Lo.frame_w);
      ctx.lineWidth = Lo.inner_w; ctx.strokeRect(M + g + Lo.inner_w / 2, M + g + Lo.inner_w / 2, CL - 2 * (M + g) - Lo.inner_w, CL - 2 * (M + g) - Lo.inner_w);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    });
  }

  function tint(maskCanvas, colour) {
    var c = document.createElement('canvas'); c.width = maskCanvas.width; c.height = maskCanvas.height;
    var x = c.getContext('2d'); x.drawImage(maskCanvas, 0, 0);
    x.globalCompositeOperation = 'source-in'; x.fillStyle = colour; x.fillRect(0, 0, c.width, c.height);
    return c;
  }

  function values() {
    var v = {};
    design.inputs.forEach(function (k) { v[k] = current(k) || DEFAULTS[k]; });
    return v;
  }

  function draw() {
    scheduled = false;
    generation++;
    var C = canvas.width, s = C / cfg.canvas, v = values();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.fillStyle = BAG[design.bag]; ctx.fillRect(0, 0, C, C);
    if (design.dropcap) return drawDropcap(design.dropcap, v.NAME, v.CRAFT || '', C);
    var gen = generation;
    return loadImage(design.base).then(function (img) {
      if (gen !== generation) return;
      // Draw on a clear sheet first, then centre the artwork on the bag - the print file does the same (centre()).
      var sheet = document.createElement('canvas'); sheet.width = sheet.height = C;
      var main = ctx; ctx = sheet.getContext('2d');
      ctx.drawImage(img, 0, 0, C, C);
      (design.fields || []).forEach(function (f) { drawLine(f, fill(f.text, v, f.case), s); });
      if (design.paragraph) drawParagraph(design.paragraph, fill(design.paragraph.text, v, design.paragraph.case), s);
      ctx = main;
      var dx = 0, dy = 0;
      try {
        var px = sheet.getContext('2d').getImageData(0, 0, C, C).data, x0 = C, y0 = C, x1 = -1, y1 = -1;
        for (var y = 0; y < C; y++) for (var x = 0; x < C; x++) {
          if (px[(y * C + x) * 4 + 3] > 20) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
        }
        if (x1 >= 0) { dx = Math.round((C - (x1 - x0 + 1)) / 2 - x0); dy = Math.round((C - (y1 - y0 + 1)) / 2 - y0); }
      } catch (e) {}                                                     // unreadable canvas: show it uncentred
      ctx.fillStyle = BAG[design.bag]; ctx.fillRect(0, 0, C, C);
      ctx.drawImage(sheet, dx, dy);
    });
  }
  function redraw() { if (!scheduled) { scheduled = true; requestAnimationFrame(draw); } }

  // ------------------------------------------------------------------ form
  var inputs = {}, craftSelect, craftOther, confirmBox, errorBox;

  function current(k) {
    if (k === 'CRAFT') {
      if (!craftSelect) return '';
      return craftSelect.value === '__other' ? craftOther.value.trim() : craftSelect.value;
    }
    return inputs[k] ? inputs[k].value.trim() : '';
  }

  function problem(k, val) {
    var label = k === 'CRAFT' ? 'craft' : 'name';
    if (!val) return k === 'CRAFT' ? 'Please choose your craft.' : 'Please type the ' + (k === 'NAME2' ? 'second name.' : 'name to print.');
    if (val.length > MAX[k]) return 'Please keep the ' + label + ' to ' + MAX[k] + ' characters.';
    if (!OK_CHARS.test(val)) return 'Please use letters only for the ' + label + ' (spaces, hyphens and apostrophes are fine).';
    if (blocked(val)) return 'Sorry, we can’t print that ' + label + '. Please try another.';
    return '';
  }

  function blocked(val) {
    var b = cfg && cfg.blocked;
    if (!b) return false;
    var plain = val.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    var leet = plain.replace(/[0134578@$]/g, function (c) { return LEET[c] || c; });
    return [plain, leet].some(function (v) {
      var words = v.split(/[^a-z0-9]+/), squashed = v.replace(/[^a-z0-9]/g, '');
      return words.some(function (w) { return b.words.indexOf(w) !== -1; }) ||
        b.anywhere.some(function (s) { return squashed.indexOf(s) !== -1; });
    });
  }

  function validate(show) {
    if (!design || !confirmBox) {                                  // box never loaded: never let an un-named bag through
      if (show && errorBox) { errorBox.textContent = 'Sorry, the personalisation box didn’t load. Please refresh the page.'; errorBox.hidden = false; }
      return false;
    }
    var msgs = [];
    design.inputs.forEach(function (k) { var m = problem(k, current(k)); if (m) msgs.push(m); });
    if (!confirmBox.checked) msgs.push('Please tick the box to confirm your spelling.');
    if (show) { errorBox.textContent = msgs[0] || ''; errorBox.hidden = !msgs.length; }
    return !msgs.length;
  }

  // The hidden fields go INSIDE the theme's form: Horizon builds its add-to-cart request from the form's own
  // contents and ignores inputs linked with form="..." (tested 10 Oct: the name never reached the cart).
  function hidden(name, value) {
    form = document.getElementById(root.dataset.form) || form;       // the theme may re-render the form
    var el = form.querySelector('input[type=hidden][data-ptote][name="' + name + '"]');
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = name; el.setAttribute('data-ptote', ''); form.appendChild(el); }
    el.value = value;
  }

  function writeProps() {
    design.inputs.forEach(function (k) { hidden('properties[' + PROP[k] + ']', current(k).replace(/\s+/g, ' ')); });
    hidden('properties[_design]', designKey);
  }

  function sync() {
    writeProps();
    design.inputs.forEach(function (k) { store.set(k, current(k)); });
    if (craftSelect) store.set('CRAFT_SELECT', craftSelect.value);
    if (!errorBox.hidden) validate(true);
    redraw();
  }

  function field(k) {
    var wrapEl = document.createElement('label'); wrapEl.className = 'ptote-field';
    var labels = LABELS[designKey] || {};
    var span = document.createElement('span');
    span.textContent = labels[k] || (k === 'NAME2' ? 'Second name' : 'Name to print');
    var input = document.createElement('input');
    input.type = 'text'; input.maxLength = MAX[k]; input.autocomplete = 'off'; input.spellcheck = false;
    input.placeholder = 'e.g. ' + DEFAULTS[k]; input.value = store.get(k);
    input.addEventListener('input', sync);
    wrapEl.appendChild(span); wrapEl.appendChild(input);
    inputs[k] = input;
    return wrapEl;
  }

  function craftField() {
    var wrapEl = document.createElement('div'); wrapEl.className = 'ptote-field';
    var span = document.createElement('label'); span.textContent = 'Your craft';
    craftSelect = document.createElement('select'); craftSelect.id = 'ptote-craft'; span.htmlFor = craftSelect.id;
    var opts = [['', 'Select craft']].concat((design.crafts || CRAFTS).map(function (c) { return [c, c]; }), [['__other', 'Other (type your own)']]);
    opts.forEach(function (o) { var op = document.createElement('option'); op.value = o[0]; op.textContent = o[1]; craftSelect.appendChild(op); });
    craftOther = document.createElement('input');
    craftOther.type = 'text'; craftOther.maxLength = MAX.CRAFT; craftOther.placeholder = 'e.g. Macramé'; craftOther.hidden = true;
    craftOther.setAttribute('aria-label', 'Your craft');
    var savedSel = store.get('CRAFT_SELECT'), saved = store.get('CRAFT');
    if (savedSel) craftSelect.value = savedSel;
    if (savedSel === '__other') { craftOther.hidden = false; craftOther.value = saved; }
    craftSelect.addEventListener('change', function () {
      craftOther.hidden = craftSelect.value !== '__other';
      if (!craftOther.hidden) craftOther.focus();
      sync();
    });
    craftOther.addEventListener('input', sync);
    wrapEl.appendChild(span); wrapEl.appendChild(craftSelect); wrapEl.appendChild(craftOther);
    return wrapEl;
  }

  function guard(e) {
    if (validate(true)) { writeProps(); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function build() {
    root.innerHTML = '';
    var h = document.createElement('p'); h.className = 'ptote-title'; h.textContent = 'Personalise your bag';
    root.appendChild(h);
    design.inputs.forEach(function (k) { root.appendChild(k === 'CRAFT' ? craftField() : field(k)); });
    canvas = document.createElement('canvas'); canvas.className = 'ptote-canvas';
    canvas.width = canvas.height = 900; canvas.setAttribute('aria-label', 'Preview of your personalised bag');
    ctx = canvas.getContext('2d');
    var note = document.createElement('p'); note.className = 'ptote-note';
    note.textContent = 'Preview of your print. We print exactly what you type, so please check the spelling.';
    var conf = document.createElement('label'); conf.className = 'ptote-confirm';
    confirmBox = document.createElement('input'); confirmBox.type = 'checkbox';
    confirmBox.addEventListener('change', function () { if (!errorBox.hidden) validate(true); });
    conf.appendChild(confirmBox); conf.appendChild(document.createTextNode(' I’ve checked the spelling and it’s ready to print'));
    errorBox = document.createElement('p'); errorBox.className = 'ptote-error'; errorBox.hidden = true; errorBox.setAttribute('role', 'alert');
    root.appendChild(canvas); root.appendChild(note); root.appendChild(conf); root.appendChild(errorBox);
    sync();
  }

  function failed() {
    root.innerHTML = '';
    errorBox = document.createElement('p'); errorBox.className = 'ptote-error'; errorBox.setAttribute('role', 'alert');
    errorBox.textContent = 'Sorry, the personalisation box didn’t load. Please refresh the page.';
    root.appendChild(errorBox);
  }

  function start() {
    if (!form) return;
    form.addEventListener('submit', guard, true);                    // block ordering until the box is filled in
    form.querySelectorAll('button[type=submit], button[name=add]').forEach(function (b) { b.addEventListener('click', guard, true); });
    // The theme's sticky "Add to Bag" bar lives outside the form and adds by script, so catch its clicks too.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.sticky-add-to-cart__button, sticky-add-to-cart button')) guard(e);
    }, true);
    if (!designKey) return failed();
    fetch(root.dataset.config).then(function (r) { return r.json(); }).then(function (c) {
      cfg = c; design = c.designs[designKey];
      if (!design) return failed();
      // Images sit next to the config file in Shopify Files: resolve their names against the config's address.
      var here = new URL(root.dataset.config, location.href);
      function abs(f) { return new URL(f, here).href.split('?')[0]; }
      if (design.base) design.base = abs(design.base);
      if (design.dropcap) Object.keys(design.dropcap.letters).forEach(function (L) {
        var l = design.dropcap.letters[L]; l.url = abs(l.file);
      });
      var families = {};
      (design.fields || []).forEach(function (f) { families[f.family] = 1; });
      if (design.paragraph) families[design.paragraph.family] = 1;
      if (design.dropcap) { families[design.dropcap.family] = 1; families[design.dropcap.body_family] = 1; }
      build();
      var loads = Object.keys(families).map(function (f) { return document.fonts.load('40px "' + f + '"', 'AÉé'); });
      Promise.all(loads).then(redraw, redraw);
    }).catch(failed);
  }
  start();
})();
